var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "info"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4442_30583",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4442_30583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "info_2",
    d: "M12.8335 20.333H15.1668V13.333H12.8335V20.333ZM14.0002 10.9997C14.3307 10.9997 14.6078 10.8879 14.8314 10.6643C15.055 10.4406 15.1668 10.1636 15.1668 9.83301C15.1668 9.50245 15.055 9.22537 14.8314 9.00176C14.6078 8.77815 14.3307 8.66634 14.0002 8.66634C13.6696 8.66634 13.3925 8.77815 13.1689 9.00176C12.9453 9.22537 12.8335 9.50245 12.8335 9.83301C12.8335 10.1636 12.9453 10.4406 13.1689 10.6643C13.3925 10.8879 13.6696 10.9997 14.0002 10.9997ZM14.0002 26.1663C12.3863 26.1663 10.8696 25.8601 9.45016 25.2476C8.03072 24.6351 6.796 23.8038 5.746 22.7538C4.696 21.7038 3.86475 20.4691 3.25225 19.0497C2.63975 17.6302 2.3335 16.1136 2.3335 14.4997C2.3335 12.8858 2.63975 11.3691 3.25225 9.94967C3.86475 8.53023 4.696 7.29551 5.746 6.24551C6.796 5.19551 8.03072 4.36426 9.45016 3.75176C10.8696 3.13926 12.3863 2.83301 14.0002 2.83301C15.6141 2.83301 17.1307 3.13926 18.5502 3.75176C19.9696 4.36426 21.2043 5.19551 22.2543 6.24551C23.3043 7.29551 24.1356 8.53023 24.7481 9.94967C25.3606 11.3691 25.6668 12.8858 25.6668 14.4997C25.6668 16.1136 25.3606 17.6302 24.7481 19.0497C24.1356 20.4691 23.3043 21.7038 22.2543 22.7538C21.2043 23.8038 19.9696 24.6351 18.5502 25.2476C17.1307 25.8601 15.6141 26.1663 14.0002 26.1663ZM14.0002 23.833C16.6057 23.833 18.8127 22.9288 20.621 21.1205C22.4293 19.3122 23.3335 17.1052 23.3335 14.4997C23.3335 11.8941 22.4293 9.68717 20.621 7.87884C18.8127 6.07051 16.6057 5.16634 14.0002 5.16634C11.3946 5.16634 9.18766 6.07051 7.37933 7.87884C5.571 9.68717 4.66683 11.8941 4.66683 14.4997C4.66683 17.1052 5.571 19.3122 7.37933 21.1205C9.18766 22.9288 11.3946 23.833 14.0002 23.833Z",
    fill: "#194893"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.2db6358852d7292d70097dd258f0cea3.svg";
export { ForwardRef as ReactComponent };